import { md5Hex } from './md5Core';

/** Same hex digest as crypto-js MD5. Kept for native cookie names during migration. */
export const encryptMD5 = (value: string): string => {
  return md5Hex(value ?? '');
};
